import Api from "../../axios"

export const getMissingStatusCount=async()=>{
    return await Api.get('/missing_report_count')
}